module.exports = __webpack_public_path__ + "img/bg.6cf0f3cd.jpg";